<template>
  <div class="checkout mb-4">
    <div class="top">
      <h1 class="title m-0 mt-2">{{ __('Pagamento') }}</h1>
      <h2 class="subtitle m-0">{{ __('Atualizar informações') }}</h2>
    </div>
    <div class="content-container mt-3">
      <div class="content">
        <BillingContentColumn class="billing-data" :title="__('Dados de faturamento')">
          <template v-slot:content>
            <div class="billing-data-inner mt-2">
              <BillingDataForm
                :show-button="false"
                :disabled="submitting"
                :errors="billingData.errors"
                @updated="(data) => updateBillingData(data)"
              />
            </div>
          </template>
        </BillingContentColumn>
        <BillingContentColumn class="payment-method" :title="__('Método de pagamento')">
          <template v-slot:content>
            <div class="payment-method-inner mt-2rem">
              <BillingPaymentMethod
                :show-button="false"
                :disabled="submitting"
                @updated="(data) => updatePaymentMethodData(data)"
              />
            </div>
          </template>
        </BillingContentColumn>
      </div>
      <footer>
        <button
          id="cancel-button"
          @click="handleCancel"
        >
          {{ __('Cancelar') }}
        </button>
        <button
          id="confirm-button"
          class="salesflow-btn salesflow-btn-secondary"
          @click="handleSubmit"
        >
          {{ ready && !submitting ? __('Salvar') : __('Aguarde') + '...'  }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import payment from '../../mixins/payment';
const Strings = require('../../services/strings.js');
import showUpgradePlanAlert from '../../mixins/showUpgradePlanAlert';

export default {
  mixins: [payment, showUpgradePlanAlert],

  data () {
    return {
      billingData: {
        data: null,
        errors: {},
        hash: null,
      },
      paymentMethodData: {
        method: null,
        data: null,
        alreadyExists: null,
        hash: null,
      },
      submitting: false,
      leaving: false,
    };
  },

  computed: {
    ready () {
      return this.billingData.data;
    },
  },

  mounted() {
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  },

  methods: {
    updateBillingData (data) {
      if (!this.billingData.hash) {
        this.billingData.hash = this.generateObjectHash(data);
      }

      this.billingData.data = data;
    },

    updatePaymentMethodData (data) {
      if (!this.paymentMethodData.hash) {
        this.paymentMethodData.hash = this.generateObjectHash(data.data);
      }

      this.paymentMethodData.data = data.data;
      this.paymentMethodData.alreadyExists = data.alreadyExists;
      this.paymentMethodData.method = data.method;
    },

    generateObjectHash (object) {
      if (object === null) {
        return null;
      }

      return Strings.simpleHash(JSON.stringify(object));
    },

    billingDataModified () {
      const hash = this.generateObjectHash(this.billingData.data);

      console.log('bd', {
        new: hash,
        old: this.billingData.hash,
        equal: hash === this.billingData.hash,
      })

      return this.billingData.hash !== hash;
    },

    paymentMethodDataModified () {
      const hash = this.generateObjectHash(this.paymentMethodData.data);

      console.log('pm', {
        new: hash,
        old: this.paymentMethodData.hash,
        equal: hash === this.paymentMethodData.hash,
      })

      return this.paymentMethodData.hash !== hash;
    },

    modified () {
      const billing = this.billingDataModified();
      const payment = this.paymentMethodDataModified();

      console.log(billing, payment);

      return (
        billing || payment
      );
    },

    async handleSubmit () {
      this.submitting = true;

      let token = null;
      try {
        token = await this.getToken();
      } catch (error) {
        this.submitting = false;

        return Alert.error('Falha ao salvar dados de cartão de crédito, verifique o preenchimento dos campos')
      }

      const data = {
        ...this.billingData.data,
        token,
        method: this.paymentMethodData.method
      };

      await this.update(data).finally(() => {
        this.submitting = false;
      });
    },

    async getToken() {
      if (this.paymentMethodData.method === 'bankslip') {
        return null;
      }

      if (!this.paymentMethodDataModified() && this.paymentMethodData.alreadyExists) {
        return null;
      }

      const { data } = this.paymentMethodData;

      console.log('data', data);

      if (!data) {
        throw new Error('Credit card data not found');
      }

      const payload = {
        number: data.number,
        month: data.validity?.get('month') + 1,
        year: data.validity?.get('year'),
        firstName: data.firstName,
        lastName: data.lastName,
        securityCode: data.securityCode,
      };

      console.log(payload);

      return this.generateToken(payload);
    },

    update (data) {
      return new Promise((resolve, reject) => {
        this.$http.put('/billing/account', data).then(() => {
          this.billingData.errors = {};

          Alert.success(this.__('Informações atualizadas com sucesso'));

          this.billingData.hash = this.generateObjectHash(this.billingData.data);
          this.paymentMethodData.hash = this.generateObjectHash(this.paymentMethodData.data);

          resolve(null);
        }).catch((response) => {
          if (response.status !== 422) {
            this.billingData.errors = {};

            Alert.error('Houve um erro inesperado ao salvar os seus dados');

            return reject(null);
          }

          Alert.error('Falha ao validar seus dados, verifique os campos enviados');

          this.billingData.errors = response.data;

          reject(null);
        }).finally(() => {
          reject(null);
        });
      });
    },

    handleCancel () {
      const modified = this.modified();

      if (!modified) {
        // console.log('/billing')
        window.location = '/billing';

        return;
      }

      this.showConfirmCancelAlert().then((data) => {
        if (!data.isDismissed) {
          // console.log('/billing')
          this.leaving = true;
          window.location = '/billing';
        }
      });
    },

    showConfirmCancelAlert () {
      return Swal.fire({
        title: this.__('Deseja cancelar a atualização dos seus dados?'),
        icon: 'question',
        width: 400,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonColor: 'transparent',
        confirmButtonText: this.__('Sim, desejo cancelar'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Voltar a editar'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-primary',
          cancelButton: 'swal2-cancel btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
      });
    },

    beforeUnloadHandler (event) {
      if (!this.modified() || this.leaving) {
        return;
      }

      this.leaving = false;

      event.preventDefault();
      event.returnValue = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.checkout {
  .top {
    margin-left: 1rem;

    .title {
      @include salesflow-text($color: $salesflow-font-gray, $font-weight: 700);
      text-transform: uppercase;
    }

    .subtitle {
      @include salesflow-title($font-weight: 500);
      font-size: 1.75rem;
    }
  }

  .content-container {
    background: $salesflow-background-content;
    border: 1px solid $salesflow-outline-gray-medium;
    border-radius: 24px;

    .content {
      display: flex;
      gap: 2.5rem;
      padding: 1.5rem;
    }

    footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1.5rem;
      padding: 1.5rem 0px;
      border-top: 1px solid $salesflow-outline-gray-medium;

      #cancel-button {
        display: flex;
        align-items: center;
        justify-content: center;
        background: $salesflow-outline-gray-light;
        border: 1px solid $salesflow-outline-gray-medium;
        border-radius: 14px;
        padding: 0.75rem;

        @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 600);

        &:hover {
          background: $salesflow-outline-gray-medium;
        }
      }
    }
  }

  .mt-2rem {
    margin-top: 2rem;
  }
}

</style>
